export type GroceriesUnit = 'gram' | 'kg' | 'piece' | 'liter' | 'none';

export const GROCERIES_UNITS: readonly GroceriesUnit[] = ['gram', 'kg', 'piece', 'liter', 'none'];
